import { Grid } from "@mui/material";
import { ReactNode } from "react";
import styles from "../css/index.module.css";

interface LeftImageAllignedContainerProps {
    children: ReactNode,
    image: any,
    dataTestIdForImage: string
}

export const LeftImageAllignedContainer = ({children, image, dataTestIdForImage}: LeftImageAllignedContainerProps) => (
    <Grid container spacing={3} className={styles.grid}  direction={{ xs: "column-reverse", md: "row" }}>
        <Grid item xs ={12} md={7}>
            <img src={image} alt="Garuda Screenshot" className={styles.screenshot} data-testid={dataTestIdForImage} />
        </Grid>
        <Grid item xs= {12} md={5}>
            {children}
        </Grid>
    </Grid>
)